import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'

import Section from '../../molecules/Section'
import CardTemplate from './CardTemplate'
import * as styles from './Showcases.module.css'
import TrustedSection from './TrustedSection'

const query = graphql`
  query PageTemplatesShowcasesQuery {
    projectShowcases: allFile(
      filter: { relativePath: { eq: "pages/templates/showcases.json" } }
    ) {
      edges {
        node {
          childTemplatesJson {
            title
            description
            cards {
              image {
                childImageSharp {
                  gatsbyImageData(
                    width: 600
                    placeholder: NONE
                    layout: CONSTRAINED
                  )
                }
              }
              title
              description
              actions {
                title
                icon {
                  publicURL
                }
                url
                hollow
                compact
                target
              }
            }
          }
        }
      }
    }
    trustedPartners: allFile(
      filter: { relativePath: { eq: "pages/templates/trustedPartners.json" } }
    ) {
      edges {
        node {
          childTemplatesJson {
            sectionTitle
            partners {
              name
              logo {
                publicURL
              }
              link
            }
          }
        }
      }
    }
  }
`

export default function Showcases() {
  const data = useStaticQuery(query)
  const { title, description, cards } =
    data.projectShowcases.edges[0].node.childTemplatesJson
  const { sectionTitle, partners } =
    data.trustedPartners.edges[0].node.childTemplatesJson

  const firstCards = cards.slice(0, 6)
  const lastCards = cards.slice(6, cards.length)

  return (
    <Section
      id="showcases"
      title={title}
      description={description}
      className={styles.section}
    >
      <div className={styles.container}>
        <div className={styles.cards}>
          {firstCards.map((card: any) => {
            return (
              <CardTemplate
                key={card}
                title={card.title}
                image={card.image}
                description={card.description}
                actions={card.actions}
              />
            )
          })}
        </div>
        <div className={styles.trustedSection}>
          <TrustedSection title={sectionTitle} partners={partners} />
        </div>
        <div className={styles.cards}>
          {lastCards.map((card: any) => {
            return (
              <CardTemplate
                key={card}
                title={card.title}
                image={card.image}
                description={card.description}
                actions={card.actions}
              />
            )
          })}
        </div>
      </div>
    </Section>
  )
}
